import script from "./richtext.vue?vue&type=script&lang=ts&setup=true"
export * from "./richtext.vue?vue&type=script&lang=ts&setup=true"

import "./richtext.vue?vue&type=style&index=0&id=582f23ff&lang=scss"

const __exports__ = script;

export default __exports__